import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const StatusBadge = ({ status, priority }) => {
  const { t } = useLanguage();

  if (priority) {
    const pClass = priority.toLowerCase();
    const priorityKey = `priority_${priority}`;
    return (
      <span className={`priority-tag priority-${pClass}`}>
        {t(priorityKey, priority)}
      </span>
    );
  }

  const statusMap = {
    'Submitted': { class: 'status-submitted', icon: 'bi-file-earmark-text', key: 'status_Submitted' },
    'Assigned': { class: 'status-assigned', icon: 'bi-person-check', key: 'status_Assigned' },
    'In Progress': { class: 'status-in-progress', icon: 'bi-gear-wide-connected', key: 'status_InProgress' },
    'Pending Customer': { class: 'status-pending-customer', icon: 'bi-hourglass-split', key: 'status_PendingCustomer' },
    'Resolved': { class: 'status-resolved', icon: 'bi-check-circle-fill', key: 'status_Resolved' },
    'Closed': { class: 'status-closed', icon: 'bi-x-circle', key: 'status_Closed' },
    'Escalated': { class: 'status-escalated', icon: 'bi-exclamation-triangle-fill', key: 'status_Escalated' }
  };

  const current = statusMap[status] || { class: 'status-submitted', icon: 'bi-info-circle', key: 'status_Submitted' };

  return (
    <span className={`status-pill ${current.class}`}>
      <i className={`bi ${current.icon}`}></i>
      {t(current.key, status)}
    </span>
  );
};

export default StatusBadge;
